export class FilterParams {
  jobTitleSelectedList: any[];
  jobTitleStatus: string;

  overallMatchFilters: any[];

  pastJobTitleSelectedList: any[];

  locationSelectedList: any[];

  skillsSelectedList: any[];

  companySelectedList: any[];
  companyStatus: string;

  companySizeSelectedList: any[];
  companysize: any;
  isCompanySizeSelected: boolean;

  industrySelectedList: any[];
  industryStatus: string;

  functionSelectedList: any[];
  // functionsInput?: any; Logic for this should be handled in filter component

  seniorityLevelSelectedList: any[];
  seniority: any;

  // yearsofexperienceFrom?: any; Logic for this should be handled in filter component
  yearsofexperienceTo?: any;
  yearsofexperienceFrom?: any;
  filterAppliedOnYearsOfExperience: boolean;
  yearsofexperience: any;

  currentfromyearsofexperience: any;
  currenttoyearsofexperience: any;
  filterAppliedOnCurrentYearsOfExperience: boolean;

  gender: any;
  isGenderSelected: boolean;
  isFemaleMatrixSelected: boolean;
  isMaleMatrixSelected: boolean;

  educationSelectedList: any[];

  schoolSelectedList: any[];
  schoolLocationSelectedList: any[]

  fieldOfStudySelectedList: any[];

  fullNameSelectedList: any[];

  filterLikelyToMoveIn: any;
  candidateslikelytomove: any;
  isLikelyToMoveInFilterSelected: boolean;

  isChangedJobsSelected: boolean;
  changedJobStatus: any;
  changedJobStartDuration: number;
  changedJobEndDuration: number;

  talentdiscoveryhistoryid: string;
  savehistory: boolean;
  continentstobeincluded: any[];
  searchHistoryRegion: string | null;

  keywordSelectedList: any[];
  booleanquery?: string;
  winningtalent: any;

  distancefromselectedlocationsmeasurementunit: string;
  distancefromselectedlocations: number

  profilehighlights: string[];

  startindex: number
  resultsize: number
  isListingActive: boolean
  isInsightsActive: boolean;
  positionhierarchy: string[] = [];

  tograduationyear?: number | string | null;
  fromgraduationyear?: number | string | null;
  jdsearchhistoryid: number
  nlsearchquery: string;
  locationcontinents?: any[];
  includePersons: string[];
  linkedinurl: string;
  isUploadedFromResume: boolean;
  screeningCriteria: string[];
  exclude_persons: string[];
  similarcandidates_excludefirstname: string = '';
  similarcandidates_excludelastname: string = '';
  similarcandidates_jobtitles: any;
  similarcandidates_companies: any;
  include_persons: string[];


  // FilterParams.ts
companyid?: string;
companyname?: string;
alternativecompanynames?: string[];
insightsFilterData?: FilterParams;   // nested read-only snapshot, never touched by the filter modal

mandatorylocations?: string[];
mandatorycompanies?: string[];
mandatoryindustries?: string[];
mandatoryschools?: string[];
mandatoryeducationalmajors?: string[];
mandatoryskills?: string[];
mandatoryjobtitles?: string[];
mandatoryfunctions?: string[];
mandatoryseniority?: string[];
lastjobcompanyids?: string[];
recentcompanyhires?: boolean;
recentcompanyattrition?: boolean;
mandatoryeducationaldegrees?: string[];
recentgraduatesonly?: boolean;
location_type?: string[];
insightsmandatoryskills?: string[];
}
